<template>
  <div class="c-location-highlights-pane">
    <a :href="`${promoGraphicUrl(location)}`"><img :src="`/perch/resources/${location.locationDynamicFields.c_promoGraphicPerch.path}`" :alt="location.locationDynamicFields.c_promoGraphicPerch.title" v-if="location.locationDynamicFields.c_promoGraphicPerch" class="c-location-highlights-pane--promo-img"></a>
    <!-- <div class="promo-graphic" v-else>
      <h1 class="c-heading__title primary-title">cool promo graphic</h1>
      <a class="c-feature-location__cta c-cta c-cta--shadow" :href="`${promoGraphicUrl(location)}`" aria-label="Learn more">learn more</a>
    </div> -->
    <h2>location highlights</h2>
    <ul class="location-highlights-list">
      <li v-for="(highlight, index) in highlights" :key="index">
        <img :src="getHighlightIcon(highlight)" @error="onImgError" :alt="highlight" />
        {{ highlight }}
      </li>
    </ul>

    <h2>about {{ location.c_locationShortName ? location.c_locationShortName.toLowerCase() : location.c_locationName }}</h2>
    <p>{{ location.description }}</p>
  </div>
</template>
<script>
import { store } from '@/store';
export default {
  props: ['location'],
  data() {
    return {
      assetPath: store.assetPath(),
      perchPath: store.perchPath(),
    };
  },
  computed: {
    highlights() {
      if (this.location.c_locationHighlights) {
        console.log(this.location.c_locationHighlights)
        return this.location.c_locationHighlights.map((highlight) =>
          highlight.replace(/_/g, ' ').toLowerCase().replace(/and/g, '&')
        );
      }
    },
  },
  methods: {
    getHighlightIcon(item) {
      return `${this.assetPath}images/icons/${item.split(' ')[0]}-icon.svg`;
    },
    onImgError(e) {
      return (e.target.src = `${this.assetPath}images/icons/circle-icon.svg`);
    },
    promoGraphicUrl(location) {
      return location.c_promoUrl || '#';
    },
  },
};
</script>
